import {createContext} from "react";

export const CheckoutContext = createContext({
    globalState: {
        billingFormRef: {},
        rulesRef: null as (null | HTMLInputElement),
        privacyRef: null as (null | HTMLInputElement),
    },
    setSiteState: (state: object) => state as (null | void | object),
});